import { Button } from '@nextui-org/react';
import { useLocation } from 'wouter';
import { ROUTES } from '../../types/api';

const MetricsPage = () => {
  const [, setLocation] = useLocation();

  const METRIC_PAGES = [
    { title: 'Estadísticas de Asker', path: ROUTES.METRICS_ASKER },
    { title: 'Estadísticas de Categorías', path: ROUTES.METRICS_CATEGORIES},
    { title: 'Estadísticas de Comunas', path: ROUTES.METRICS_COMMUNES },
    {
      title: 'Número y % de Tasks por bloque horario de cada día',
      path: ROUTES.METRICS_TASKERS,
    },
    { title: 'Estadísticas de Género', path: ROUTES.METRICS_GENDER},
    { title: 'Número de Tasks completados', path: ROUTES.METRICS_COMPLETION },
    {
      title: 'Categorías por bloque horario',
      path: ROUTES.METRICS_CATEGORY_TIMEBLOCK,
    },
    { title: 'Ventas por día', path: ROUTES.METRICS_SALES_PER_DAY },
    { title: 'Ventas por helper', path: ROUTES.METRICS_SALES_PER_HELPER },
    {
      title: 'Tasks por comuna y categoría',
      path: ROUTES.METRICS_TASKS_PER_COMMUNE_PER_CATEGORY,
    },
    {
      title: 'Tasks por comuna y sexo',
      path: ROUTES.METRICS_TASKS_PER_COMMUNE_PER_SEX,
    },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Métricas</h1>
      <ul className="divide-y divide-gray-200">
        {METRIC_PAGES.map((page, index) => (
          <li key={index} className="py-4 flex justify-between items-center">
            <span className="text-lg">{page.title}</span>
            <Button onClick={() => setLocation(page.path)}>Ver</Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MetricsPage;
